(function () {
  var moneyFormat = (window.theme && window.theme.settings && window.theme.settings.moneyFormat) || '{{ amount }}';

  function formatMoney(cents) {
    if (cents == null) return '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = moneyFormat.match(placeholderRegex);
    if (!match) return String(Math.round(cents / 100));

    function formatWithDelimiters(n, precision, thousands, decimal) {
      if (isNaN(n)) return '0';
      var str = (n / 100).toFixed(precision);
      var parts = str.split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[0] + (parts[1] ? decimal + parts[1] : '');
    }

    var value;
    switch (match[1]) {
      case 'amount':                                    value = formatWithDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals':                        value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_comma_separator':               value = formatWithDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator':   value = formatWithDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator':          value = formatWithDelimiters(cents, 2, "'", '.'); break;
      default:                                          value = formatWithDelimiters(cents, 2, ',', '.'); break;
    }

    return moneyFormat.replace(placeholderRegex, value);
  }

  function initCard(card) {
    var selects = card.querySelectorAll('.cyl-option');
    var addWrap = card.querySelector('.cyl-card__add');
    var btn = card.querySelector('.cyl-add-btn');
    var priceEl = card.querySelector('.cyl-card__price');
    if (!btn) return;

    var addText = btn.dataset.addText || btn.textContent.trim();
    var soldOutText = btn.dataset.soldOutText || addText;

    var variants = [];
    try { variants = JSON.parse(card.querySelector('.cyl-variants-json').textContent); } catch (e) {}

    function applyVariant(v) {
      if (!v) {
        addWrap.dataset.variantId = '';
        btn.disabled = true;
        btn.textContent = soldOutText;
        return;
      }

      addWrap.dataset.variantId = v.id;

      var cap = Number(v.compare_at_price);
      var price = Number(v.price);
      if (cap && cap > price) {
        priceEl.innerHTML = '<s>' + formatMoney(cap) + '</s> ' + formatMoney(price);
        priceEl.classList.add('cyl-card__price--sale');
      } else {
        priceEl.textContent = formatMoney(price);
        priceEl.classList.remove('cyl-card__price--sale');
      }

      if (!v.available) {
        btn.disabled = true;
        btn.textContent = soldOutText;
      } else {
        btn.disabled = false;
        btn.textContent = addText;
      }
    }

    function updateVariant() {
      if (!variants.length) return;
      if (!selects.length) { applyVariant(variants[0]); return; }
      var opts = Array.from(selects).map(function (s) { return s.value; });
      var match = variants.find(function (v) {
        return opts.every(function (o, i) { return v['option' + (i + 1)] === o; });
      });
      applyVariant(match || null);
    }

    selects.forEach(function (s) { s.addEventListener('change', updateVariant); });
    updateVariant();

    btn.addEventListener('click', function () {
      var variantId = addWrap.dataset.variantId;
      if (!variantId || btn.disabled) return;

      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: Number(variantId), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) return res.json().then(function (d) { throw d; });
          return res.json();
        })
        .then(function () {
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
        })
        .catch(function () {})
        .finally(function () {
          updateVariant();
        });
    });
  }

  function initContainer(container) {
    container.querySelectorAll('.cyl-card').forEach(initCard);
  }

  window.CylCard = { init: initContainer };

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.cyl-card').forEach(initCard);
  });
})();
